import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m7.476 2.195c.798-.578 2-1.185 3.524-1.185s2.726.607 3.524 1.185a7 7 0 0 1 1.171 1.075l.07.085.021.027.008.01.002.003.002.002v.001a1 1 0 0 1-1.593 1.208L15.2 16.6l-.034-.04q-.05-.061-.16-.177a5 5 0 0 0-.655-.568c-.577-.417-1.375-.805-2.35-.805-.977 0-1.775.388-2.352.805a5 5 0 0 0-.815.744L8.8 16.6l-.005.006a1 1 0 0 1-1.593-1.208v-.001l.002-.002.002-.003.008-.01.021-.027.07-.085q.089-.107.248-.275c.212-.22.522-.51.923-.8m-.029-4.028A1 1 0 0 0 9 12h.01a1 1 0 0 0 1-1 .998.998 0 0 0 .545-1.832l-3-2a1 1 0 0 0-1.11 1.664zm7.11-.004 1.998-1.33a1 1 0 0 0-1.11-1.665l-3 2A1 1 0 0 0 14 11a1 1 0 0 0 1 1h.01a1 1 0 0 0 .548-1.837",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }